const PlansIcon = ({ fill }: { fill: string }) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="3.00195"
			y="6"
			width="17.9956"
			height="12"
			rx="2"
			fill={fill || "#D3D4D9"}
		/>
	</svg>
);

export default PlansIcon;
